import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  fetchAndApplySubscriptionAccess,
  getSubscriptionLockedFallbackPath,
  isSubscriptionExemptPath,
  isSubscriptionLocked,
} from "../../utils/subscriptionAccess";
import LoadingSpinner from "./LoadingSpinner";

/**
 * Verifies subscription once per client, then blocks protected routes synchronously.
 */
const SubscriptionGate = ({ children }) => {
  const user = useSelector((state) => state?.user);
  const location = useLocation();
  const [verified, setVerified] = useState(!user?.client_id);

  useEffect(() => {
    if (!user?.client_id) {
      setVerified(true);
      return;
    }

    let cancelled = false;
    setVerified(false);

    fetchAndApplySubscriptionAccess(user.client_id).finally(() => {
      if (!cancelled) {
        setVerified(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [user?.client_id]);

  if (!user?.client_id) {
    return children;
  }

  if (!verified) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5 min-vh-50">
        <LoadingSpinner />
      </div>
    );
  }

  if (
    isSubscriptionLocked(user) &&
    !isSubscriptionExemptPath(location.pathname, user)
  ) {
    return (
      <Navigate to={getSubscriptionLockedFallbackPath(user)} replace />
    );
  }

  return children;
};

export default SubscriptionGate;
